import * as React from 'react'
import { styled } from 'next-yak'

import * as model from '@owl-nest/models'
import * as plume from '@ulule/owl-kit-components/next'

import { useStep } from './useStep'
import { Progress } from './components/Progress'

type LayoutProps = {
  project: model.project.ProjectForOwner
  children: React.ReactNode
  withProgress?: boolean
}

export function Layout({ project, children, withProgress = true }: LayoutProps) {
  const { step } = useStep(project)

  return (
    <OnboardingModal lockScroll open={step !== undefined} $withProgress={withProgress}>
      {children}
    </OnboardingModal>
  )
}

const OnboardingModal = styled(plume.Modal)<{ $withProgress: boolean }>`
  ${plume.styles.modal.Body} {
    height: calc(100% - 162px);

    @media screen and ${plume.BREAKPOINTS.TABLET} {
      height: unset;
    }
  }

  ${plume.styles.modal.Wrapper} {
    &::before {
      background: transparent;
      height: ${({ $withProgress }) => ($withProgress ? 60 : 0)}px;
    }

    @media screen and ${plume.BREAKPOINTS.TABLET} {
      border-radius: 8px;
      overflow: scroll;
      width: 60vw;
      max-width: 800px;
      max-height: 90vh;
    }

    ${Progress} {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }
  }
`
